export interface Magnet { x: number; y: number; strength: number; reach: number }
export interface FieldSample { vx: number; vy: number; influence: number }

/** Reuses one output for the whole particle loop; no per-particle allocations. */
export function sampleMagneticField(x: number, y: number, magnet: Magnet, out: FieldSample): void {
  out.vx = 0; out.vy = 0; out.influence = 0;
  const dx = x - magnet.x, dy = y - magnet.y;
  const distanceSquared = dx * dx + dy * dy;
  if (magnet.strength <= 0 || distanceSquared >= magnet.reach * magnet.reach || distanceSquared < .25) return;
  const distance = Math.sqrt(distanceSquared);
  const influence = (1 - distance / magnet.reach) * magnet.strength;
  const pull = influence * 5.2, spin = influence * 3.8;
  out.vx = (-dx * pull - dy * spin) / distance;
  out.vy = (-dy * pull + dx * spin) / distance;
  out.influence = influence;
}
